import { useEffect, useRef } from "react";

// @ts-expect-error TS(2322): Type 'null' is not assignable to type 'T'.
export function usePrevious<T>(value: T, initialValue: T = null): T {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  const ref = useRef<T>(initialValue);

  // Store current value in ref
  useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes

  // Return previous value (happens before update in useEffect above)
  return ref.current;
}
